angular.module('leanlaw').controller('AttorneyRevenueDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$window', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'leanLawApi', 'accountingService', "exportJson", "messageBus", "matterManager", "singleRequest", function ($scope, $rootScope, $q, $filter, $window, $state, $stateParams, alerts, userService, reportsService, leanLawApi, accountingService, exportJson, messageBus, matterManager, singleRequest) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    $window.print();
  };
  $scope.go = function (options) {
    options.accountId = $stateParams.id;
    $state.go('reports.attorney-revenue-invoices', options);
  };
  function itemData(item, data) {
    item["Worked"] = $filter("amount")(data.collected.servicesTotal);
    item["Worked Share"] = $filter("amount")(data.origination.share);
    if ($scope.data.data.origination.debit) {
      item["Origination"] = $filter("amount")(data.origination.originatorDebit);
    }
    if ($scope.me.company.settings.report?.responsibleContribution) {
      item["Responsible"] = $filter("amount")(data.origination.responsibleDebit);
    }
    if ($scope.me.features.referral) {
      item["Referrals"] = $filter("amount")(data.origination.referralDebit);
    }
    if ($scope.me.company.settings.report?.customPlan) {
      item["Firm Share"] = $filter("amount")(data.origination.firmDebit);
    }
    if ($scope.data.data.origination.debit) {
      item["Total"] = $filter("amount")(data.origination.adjusted);
    }
    if ($scope.filter.showExpense) {
      item["Expenses"] = $filter("amount")(data.collected.expensesUsers);
    }
    if ($scope.me.features.referral && $scope.data.data.collected.expensesServices) {
      item["Service Expenses"] = $filter("amount")(data.collected.expensesServices);
    }
  }
  function itemPrepare() {
    const item = {};
    if ($scope.clientReferences) {
      item["Client Id"] = "";
    }
    item["Client"] = "";
    if ($scope.filter.include && $scope.filter.include.matters) {
      if ($scope.references) {
        item["Matter Id"] = "";
      }
      item["Matter"] = "";
    }
    return item;
  }
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.reduce((accum, c) => {
      const item = itemPrepare();
      if ($scope.clientReferences) {
        item["Client Id"] = c.client.reference;
      }
      item["Client"] = c.client.name;
      itemData(item, c.data);
      accum.push(item);
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          const matterItem = itemPrepare();
          if ($scope.references) {
            matterItem["Matter Id"] = m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '';
          }
          matterItem["Matter"] = m.matter.name;
          itemData(matterItem, m.data);
          accum.push(matterItem);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    $q.all([userService.me(), leanLawApi.getAccount({
      id: $stateParams.id
    })]).then(([me, user]) => {
      $scope.me = me;
      $scope.user = user;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let _cancelReport = null;
  function filterClientEntries() {
    if (_cancelReport) {
      _cancelReport.resolve("reloading");
    }
    _cancelReport = $q.defer();
    const query = reportsService.queryFromFilter($scope.filter);
    query.account = $scope.user.id;
    query.data = "payments";
    query.billed = 'any';
    query.billedState = undefined;
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.$timeout = _cancelReport.promise;
    query.reportType = 'revenue';
    $scope.loading = true;
    singleRequest.apiCall("attorney-revenue-detail", true).getReport(query).then(data => {
      if (!data) return; // happens if we were cancelled
      matterManager.list(query).then(matters => {
        $scope.references = !!matters.find(m => m.reference);
        $scope.clientReferences = !!matters.find(m => m.client.reference);
      });
      $scope.loading = false;
      $scope.data = data;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("attorney-revenue-detail");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filtered.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);